const Helpers = {
	removeVisibility(elementToHide) {
		return elementToHide?.classList.add('hide');
	},

	addVisibility(elementToShow) {
		return elementToShow?.classList.remove('hide');
	},
	// eslint-disable-next-line consistent-return
	scrollTo(scrollDuration, element) {
		let y;
		if (!element) {
			y = 0;
		} else if (element && !this.isInViewport(element)) {
			y = element.getBoundingClientRect().top;
		} else {
			return false;
		}
		const cosParameter = window.scrollY / 2;
		let scrollCount = 0;
		let oldTimestamp = performance.now();
		function step(newTimestamp) {
			scrollCount += Math.PI / (scrollDuration / (newTimestamp - oldTimestamp));
			if (scrollCount >= Math.PI) window.scrollTo(0, y);
			if (window.scrollY === y) return;
			window.scrollTo(0, Math.round(cosParameter + cosParameter * Math.cos(scrollCount)));
			oldTimestamp = newTimestamp;
			window.requestAnimationFrame(step);
		}
		window.requestAnimationFrame(step);
	},
	isInViewport(element) {
		const bounding = element.getBoundingClientRect();
		return (
			bounding.top >= 0 &&
			bounding.left >= 0 &&
			bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
			bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
		);
	},
	getUrlVars() {
		const vars = {};
		window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m, key, value) => {
			vars[key] = value;
		});
		return vars;
	},

	disableAllButtons() {
		const btns = Array.from(
			document.querySelectorAll('input[type=button], input[type=submit], button, a.btn')
		);
		btns.forEach((btn) => {
			btn.setAttribute('disabled', true);
			btn.classList.add('disabled');
			const button = btn;
			button.style.pointerEvents = 'none';
		});
	},

	enableAllButtons() {
		const btns = Array.from(
			document.querySelectorAll('input[type=button], input[type=submit], button, a.btn')
		);
		btns.forEach((btn) => {
			btn.removeAttribute('disabled');
			btn.classList.remove('disabled');
			const button = btn;
			button.style.pointerEvents = 'auto';
		});
	},

	checkWhitespace(text) {
		const re = /\S/;
		return re.test(text);
	},

	bytesToMB(bytes) {
		if (bytes === 0) return 0;
		const k = 1024;

		return parseFloat((bytes / k / k).toFixed(0));
	},

	saveCodeMirrorInput() {
		if (document.querySelectorAll('.CodeMirror')) {
			document.querySelectorAll('.CodeMirror').forEach((el) => {
				el.CodeMirror.save();
			});
		}
	},

	renderPreview(insertNode, fileSrc) {
		this.handlePlaceholder(insertNode, true);

		const fileExtension = fileSrc.split('.').pop().toLowerCase();

		if (this.containsImageExtension(fileExtension)) {
			this.removeFileIcon(insertNode);
			this.renderImage(insertNode, fileSrc);
		} else {
			// Render generic file icon or message
			this.renderFileIcon(insertNode);
			this.removeImage(insertNode);
		}
	},

	containsImageExtension(text) {
		const supportedImageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp'];
		return supportedImageExtensions.some((extension) => text.includes(extension));
	},

	removeImage(insertNode) {
		const img = insertNode.querySelector('figure');
		if (img) {
			img.remove();
		}
	},

	removeFileIcon(insertNode) {
		const fileIcon = insertNode.querySelector('img');
		if (fileIcon) {
			fileIcon.remove();
		}
	},

	renderImage(insertNode, imgSrc) {
		const figure = insertNode.querySelector('figure')
			? insertNode.querySelector('figure')
			: document.createElement('FIGURE');
		figure.classList.add('preview-img');
		figure.innerHTML = `<img src="${imgSrc}">`;
		insertNode.insertBefore(figure, insertNode.firstChild);
	},

	renderFileIcon(insertNode) {
		const fileIcon = document.createElement('img');
		fileIcon.src = `/images/file-placeholder.svg`;
		fileIcon.alt = 'Attachment Icon';
		insertNode.insertBefore(fileIcon, insertNode.firstChild);
	},

	handlePlaceholder(insertNode, removePlaceholder = false) {
		const placeholder = insertNode.getElementsByClassName('upload-placeholder')[0];
		if (placeholder) {
			if (removePlaceholder) {
				placeholder.classList?.add('hidden');
			} else {
				placeholder.classList?.remove('hidden');
			}
		}
	},

	createRegexExpr(element) {
		const reg = `(${element})(?![^<]*>|[^<>]*</)`;
		const regex = new RegExp(reg, 'i');
		return regex;
	},

	getCookie(cookieName) {
		const cookie = {};
		document.cookie.split(';').forEach((el) => {
			const [key, value] = el.split('=');
			cookie[key.trim()] = value;
		});
		return cookie[cookieName];
	},

	setCookie(cookieKey, cookieValue, expirationDays) {
		let expiryDate = '';
		if (expirationDays) {
			const date = new Date();
			date.setTime(date.getTime() + expirationDays * 24 * 60 * 60 * 1000);
			expiryDate = `; expires= "${date.toUTCString()}`;
		}

		document.cookie = `${cookieKey}=${cookieValue}${expiryDate}; path=/ `;
	},

	pushParameters(params) {
		window.history.pushState({}, '', `${window.location.pathname}?${params}`);
		// trigger popstate event cause pushState does not trigger it
		const queryStringChange = new Event('popstate');
		window.dispatchEvent(queryStringChange);
	},

	getSearchParams(params) {
		let filterParamsArr = [];
		if (params != null) {
			filterParamsArr = params.split(',').map((item) => item.trim());
		}
		return filterParamsArr;
	},

	removeItem(array, value) {
		const index = array.indexOf(value);
		if (index > -1) {
			array.splice(index, 1);
		}
		return array;
	},

	addHiddenIdField(form) {
		const hiddenInput = document.createElement('input');
		hiddenInput.type = 'hidden';

		// Generate a random number
		const randomNumber = Math.floor(Math.random() * (3000 - 1000 + 1)) + 1000;

		// Set the value of the hidden input to the random number
		hiddenInput.value = randomNumber;

		hiddenInput.name = 'id';

		// Append the hidden input to the form
		form.appendChild(hiddenInput);
	},
};

export default Helpers;
